export let supportedLanguages = [
    {slug:'en',name:"english"},
    {slug:'ar',name:"arabic"}
]